import { QuestionBase } from './question-base';

export class UpLoadQuestion extends QuestionBase<string> {
     ptctNo = 'upload';
}
